import React, { useEffect, useState } from 'react'
import {
    Box, 
    Alert, 
    CircularProgress,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@mui/material'
import { AxiosWithAuth } from '../../Utilities/authenticationService'
import { PATHS } from '../../constants'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { displayNameWithSpace } from '../../Utilities/japaneseStringUtils'
import { isMobile } from '../../Utilities/isMobile'
import { useParams } from 'react-router-dom'
import UserSearch from '../AdminSettings/UserSearch'

const UserManagementList = () => {
    const history = useHistory()
    const { employmentId } = useParams()
    const [employments, setEmployments] = useState()
    const [message, setMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const [store, setStore] = useState()

    useEffect(() => {
        setLoading(true)
        AxiosWithAuth.get('/calendars/dailyShifts', {
            params: {
                employment_id: localStorage.getItem('selected_emp'),
                date: moment()
            }
        })
            .then(res => {
                setEmployments(res?.data.employments.sort((a, b) => a.order - b.order))
                setStore(res?.data.store)
            })
            .catch(err => {
                if (err.response?.status === 403) {
                    setMessage('選択した店舗の店長ではありません。')
                    setEmployments([])
                } else {
                    setMessage('エラーが発生しました。')
                }
            })
            .finally(() => setLoading(false))
    }, [employmentId])

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                {message?.length > 0 && (
                    <Alert
                        style={{ width: '390px', alignSelf: 'center' }}
                        onClose={() => setMessage('')}
                        severity="error"
                    >
                        {message}
                    </Alert>
                )}
            </div>
            {history?.location?.pathname?.includes('deleted') && (
                <Box className="input-box shrinkable">
                    <Alert sx={{ mx: '1rem' }} severity="success">
                        ユーザー{history.location.pathname.split(':')[1]}
                        を削除しました。
                    </Alert>
                </Box>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <UserSearch path={`${PATHS.managerSettingsUsers}noEmployment/`} history={history} />
            </div>
            {loading ? (
                <CircularProgress />
            ) : employments && employments.length > 0 ? (
                <Table sx={{ width: !isMobile ? '45rem' : '99%', marginTop: '1rem', marginBottom: isMobile() && '3rem' }} size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: isMobile() ? '4rem' : '5rem' }} align="left">
                                ユーザー名
                            </TableCell>
                            <TableCell sx={{ width: isMobile() ? '4rem' : '5rem' }} align="left">
                                社員番号
                            </TableCell>
                            <TableCell sx={{ width: isMobile() ? '4rem' : '5rem' }} align="left">
                                勤務店舗先
                            </TableCell>
                            <TableCell sx={{ width: isMobile() ? '4rem' : '5rem' }} align="left">
                                サポート店舗
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {employments?.map(e => {
                            return (
                                <TableRow key={e.user.emp_cd} onClick={() => {
                                    history.push(PATHS.managerSettingsUser.replace(":userId", e.user.id).replace(':userEmpId', e.id))
                                }} style={{ cursor: 'pointer' }}>
                                    <TableCell align="left">{displayNameWithSpace(e.user)}</TableCell>
                                    <TableCell align="left">{e.user.emp_cd}</TableCell>
                                    <TableCell align="left">{store?.name}</TableCell>
                                    <TableCell align="left">{e.support_stores?.map(s => s.name).join(', ')}</TableCell>
                                </TableRow>
                            )}
                        )}
                    </TableBody>
                </Table>
            ) : null}
        </>
    )
}

export default UserManagementList
